export default function PreparationItemDocumentDirective() {
  return {
    template: require('./preparation-item-document.html'),
    scope: {
      preparationItemId: '=',
      canEdit: '=',
      canDelete: '=',
      preparationItemDocument: '=',
    },
    controller: 'PreparationItemDocumentController',
    controllerAs: 'preparationItemDocumentVM',
    bindToController: true,
    replace: true
  };
}
